import { render } from "./TriStateCheckbox.vue?vue&type=template&id=95204644"
import script from "./TriStateCheckbox.vue?vue&type=script&lang=js"
export * from "./TriStateCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script